export const isMacOs = () => {
  return navigator?.userAgent?.includes("Mac");
};

export const isIOS = () => {
  return navigator?.userAgent?.includes("iPhone") || navigator?.userAgent?.includes("iPad") || navigator?.userAgent?.includes("iPod");
};

export const getControlKey = () => {
  return isMacOs() ? "⌘" : "Ctrl";
};
